import { render, staticRenderFns } from "./RelatedDocumentIncomingContainerDialog.vue?vue&type=template&id=318aff36&"
import script from "./RelatedDocumentIncomingContainerDialog.vue?vue&type=script&lang=js&"
export * from "./RelatedDocumentIncomingContainerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports